import { ApolloError } from "@apollo/client";
import { useEffect } from "react";
import { Notification, useToaster } from "rsuite";
import WarningIcon from "../components/icons/WarningIcon";

export function useSelectAllErrorToast(
  selectAllError: ApolloError | undefined,
  clearSelectAllError: () => void,
) {
  const toaster = useToaster();

  useEffect(() => {
    if (!selectAllError) return;

    const detail = selectAllError.graphQLErrors?.[0]?.message;
    toaster.push(
      <Notification>
        <div className="d-flex flex-row gap-3 align-items-center">
          <span className="c-theme-icon bg-danger text-white">
            <WarningIcon />
          </span>
          <div className="d-flex flex-column gap-1">
            Du har valgt for mange elementer. Prøv igen med et mindre antal.
            {detail && (
              <>
                <br />
                <small className="text-muted">{detail}</small>
              </>
            )}
          </div>
        </div>
      </Notification>,
      {
        placement: "bottomEnd",
        duration: 8000,
      },
    );

    clearSelectAllError();
  }, [selectAllError, clearSelectAllError, toaster]);
}
